var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-table", {
    attrs: {
      fields: _vm.fields,
      items: _vm.items,
      "table-class": "text-nowrap",
      responsive: "",
      hover: "",
    },
    on: { "row-clicked": _vm.onClickRow },
    scopedSlots: _vm._u([
      {
        key: "cell(source)",
        fn: function (data) {
          return [
            _c("admin-order-badge", {
              staticClass: "text-uppercase",
              attrs: {
                text: data.item.order.source.code,
                value: data.item.order.source.code,
                type: "source",
                pill: "",
              },
            }),
          ]
        },
      },
      {
        key: "cell(seller)",
        fn: function (data) {
          return [
            data.item.order.seller_license
              ? [
                  _c("h4", { staticClass: "mb-0" }, [
                    _vm._v(_vm._s(data.item.order.seller_license.number)),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(data.item.order.seller_license.facility.name)
                    ),
                  ]),
                ]
              : data.item.order.seller_info
              ? [
                  _c("h4", { staticClass: "mb-0" }, [
                    _vm._v(_vm._s(data.item.order.seller_info.license_number)),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(data.item.order.seller_info.name)),
                  ]),
                ]
              : _vm._e(),
          ]
        },
      },
      {
        key: "cell(buyer)",
        fn: function (data) {
          return [
            data.item.order.buyer_license
              ? [
                  _c("h4", { staticClass: "mb-0" }, [
                    _vm._v(_vm._s(data.item.order.buyer_license.number)),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(data.item.order.buyer_license.facility.name)),
                  ]),
                ]
              : _vm._e(),
          ]
        },
      },
      {
        key: "cell(status)",
        fn: function (data) {
          return [
            _c("admin-order-badge", {
              attrs: {
                text: data.item.order.status.name,
                value: data.item.order.status.code,
                type: "status",
              },
            }),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }